// @flow

export default ({
  ...extra
}: jsx$HTMLElement): ExactReactElement_DEPRECATED<'svg'> => ( // $FlowFixMe[cannot-spread-inexact]
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...extra}>
    <path
      d="M8 0C3.58737 0 0 3.58737 0 8C0 12.4126 3.58737 16 8 16C12.4126 16 16 12.4126 16 8C16 3.58737 12.4126 0 8 0ZM8 2.13053C9.20421 2.13053 10.3495 2.48421 11.3347 3.16632L3.16632 11.3347C2.48421 10.3495 2.13053 9.20421 2.13053 8C2.13053 4.75789 4.76632 2.13053 8 2.13053ZM8 13.8695C6.79579 13.8695 5.65053 13.5158 4.66526 12.8337L12.8337 4.66526C13.5158 5.65053 13.8695 6.79579 13.8695 8C13.8695 11.2337 11.2337 13.8695 8 13.8695Z"
      fill="#757575"
    />
  </svg>
);
